import { Box, Grid, useToast} from "@chakra-ui/react";
import TradeTable from "views/admin/trades/components/TradeTable";
import DateFilter from "components/filter/DateFilter";
import Paginate from 'components/filter/Pagination';
import React, {useEffect,useState} from "react";
import axios from "axios";
const {DateTime} = require("luxon");

export default function BuyTrade() {

  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const [loading,setLoading] = useState(false);
  const [trades,setTrades] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [from,setFrom] = useState(0);
  const [limit] = useState(20);
  const [date,setDate] = useState(DateTime.now().toFormat('yyyy-MM-dd'));
  const token = localStorage.getItem("authToken");
  const toast = useToast();
  
  const initFilterSubmit = async()=>{
    try{
      setLoading(true);
      const {data:response} = await axios.post(SERVER_URL+'/buy/alltrades',{createdAt:date,from,limit},{
        headers:{
          "Authorization":`Bearer ${token}`
        }
      });
      if(response.error){
        toast({
          title: response.error || "An error occured",
          status: 'error',
          duration: 9000,
          position:'top-right',
          isClosable: true,
        })
      }
      if(!response.success){
        toast({
          title: response.message || "An error occured",
          status: 'error',
          duration: 9000,
          position:'top-right',
          isClosable: true,
        })
      }
      if(response.success){
          setLoading(false);
          setTrades(response.data.trades);
          setPageCount((response.data.count/limit))
         return
       }
     }
    catch(error){
      setLoading(false);
      toast({
        title: error.message || "An error occured",
        status: 'error',
        duration: 9000,
        position:'top-right',
        isClosable: true,
      })
    }
}

useEffect(()=>{  
  initFilterSubmit();
},[token])

  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }} overflow='hidden' width={{ base: '100%', sm: '100%', md: '100%' }}>
      <div class="overlay" style={{display:loading?'block':'none'}}>
        <div class="spinner"></div>
        <br/>
          Please Wait...
      </div>
      
      <Grid
        w='100%' p='10px'>
        <DateFilter date={date} setDate={setDate} initFilterSubmit={initFilterSubmit} />
        <TradeTable trades={trades}  pageCount={pageCount} tradeType="Buy Trades" />
        <Paginate pageCount={pageCount} setFrom={setFrom} getRecords={initFilterSubmit} />
      </Grid>
    </Box>
  );
}
